import { Pipe, PipeTransform } from '@angular/core';
// Credit to https://github.com/thekelvinliu for this pipe.

// Country code regex
const CC_REGEX = /^[a-z]{2}$/i;
// Offset between uppercase ascii and regional indicator symbols
const OFFSET = 127397;

@Pipe({
    name: 'countryFlag',
    pure: true,
    standalone: false
})
export class CountryFlagPipe implements PipeTransform {
  public transform(countryCode: string) {
    if (!CC_REGEX.test(countryCode)) {
      const type = typeof countryCode;
      throw new TypeError(
        `countryCode argument must be an ISO 3166-1 alpha-2 string, but got '${
          type === 'string' ? countryCode : type
        }' instead.`
      );
    }

    const chars = [...countryCode.toUpperCase()].map((c) => c.charCodeAt(0) + OFFSET);
    return String.fromCodePoint(...chars);
  }
}
